import { type ChainflipChain } from '@chainflip/utils/chainflip';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import { boostChainflipBlocksDelayQuery } from '../graphql/cache/boost';

export const useBoostChainflipBlocksDelay = (chain: ChainflipChain) => {
  const { isLoading, data } = useGqlQuery(boostChainflipBlocksDelayQuery, {
    context: { clientName: 'statechainCache' },
    variables: { chain },
  });

  return {
    isLoading,
    data: data?.allBoostDelayChainflipBlocks?.nodes.reduce(
      (acc, node) => ({
        ...acc,
        [node.chain]: node.numBlocks,
      }),
      {} as Record<ChainflipChain, number>,
    ),
  };
};
